'use client'

import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { Button } from '@lastbrand/web-ui/button'
import { useTranslation } from 'next-i18next'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface } from '@src/components/pl-base-widget'
import { showReviewSection } from '@src/quince-components/src/atoms/reviewHighLightsSection/reviewHighLightsSection.helpers'
import reviewHighlightStyles from '@src/quince-components/src/atoms/reviewHighLightsSection/reviewHighlightsSectionV2.module.scss'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

// ---------------- REVIEWS_ALL_BUTTON (See all reviews CTA) ----------------
function ReviewsAllButtonWidgetComponent() {
  const { t } = useTranslation('common')

  if (shouldUseDesignSystem()) {
    return (
      // Fixed 170px wrapped the label to 2 lines and ballooned the pill; `fit-content` hugs the
      // text instead, matching the legacy `max-content` pill below.
      <Button
        variant="tertiary"
        size="lg"
        css={{ width: 'fit-content', alignSelf: 'flex-start' }}
        onClick={showReviewSection}
      >
        {t('see_all_reviews')}
      </Button>
    )
  }

  // Reuse the legacy mobile "See all reviews" pill styling.
  return (
    <div
      className={reviewHighlightStyles.container__wrapper__seeAllReviews}
      role="button"
      tabIndex={0}
      onClick={showReviewSection}
    >
      <span>{t('see_all_reviews')}</span>
    </div>
  )
}

export const ReviewsAllButtonWidget: PLTypedWidgetInterface<never, WidgetType.REVIEWS_ALL_BUTTON> = {
  id: WidgetType.REVIEWS_ALL_BUTTON,
  errorBoundary: PLBaseErrorBoundary,
  render: ReviewsAllButtonWidgetComponent,
}
